// userSelectors.js

export const selectDeleteUserDetails = (state) => state.deleteAccount.deleteUserDetails;
export const selectLoading = (state) => state.deleteAccount.loading;
export const selectVerificationDetails = (state) => state.deleteAccount.verificationDetails;
